module.exports = __webpack_public_path__ + "img/morningglow.5abf277.jpg";